import { render, staticRenderFns } from "./u-textarea-outlined-tile.vue?vue&type=template&id=003b7f84&scoped=true"
import script from "./u-textarea-outlined-tile.vue?vue&type=script&lang=js"
export * from "./u-textarea-outlined-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003b7f84",
  null
  
)

export default component.exports